import { render, staticRenderFns } from "./FrameworkInUseView.vue?vue&type=template&id=40bbd2f4&scoped=true"
import script from "./FrameworkInUseView.vue?vue&type=script&setup=true&lang=js"
export * from "./FrameworkInUseView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FrameworkInUseView.vue?vue&type=style&index=0&id=40bbd2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbd2f4",
  null
  
)

export default component.exports